import { render, staticRenderFns } from "./HelpCenterFooter.vue?vue&type=template&id=1add521b&scoped=true"
import script from "./HelpCenterFooter.vue?vue&type=script&lang=ts"
export * from "./HelpCenterFooter.vue?vue&type=script&lang=ts"
import style0 from "./HelpCenterFooter.vue?vue&type=style&index=0&id=1add521b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1add521b",
  null
  
)

export default component.exports